import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { IStoreState } from "../../../../reducers/types";
import {
  getPremierCollectionShopCancellationSummary,
  PremierCollectionShopCallState,
} from "../../reducer";
import {
  getCheapestProduct,
  getPremierCollectionShopCallState,
  getPremierCollectionShopChosenProduct,
  getPremierCollectionShopSelectedAvailability,
  getViewedPremierCollectionDetailsProperties,
  hasPremierCollectionShopFailed,
  premierCollectionShopProgressSelector,
} from "../../reducer/selectors";
import { MobileShop } from "./component";
import {
  getRewardsAccountWithLargestEarnForBanner,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../../../rewards/reducer";
import { getNightCount } from "../../../search/reducer";
import {
  getShopCallFailureUrl,
  getShopCallFromShopDetails,
} from "../../../shop-details/reducer";
import { actions as shopDetailsActions } from "../../../shop-details/actions";
import { setIsTravelApp } from "../../../availability/actions/actions";
import { getIsTravelApp } from "../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    lodging: getPremierCollectionShopSelectedAvailability(state),
    premierCollectionShopCallInProgress:
      getPremierCollectionShopCallState(state) ===
      PremierCollectionShopCallState.InProcess,
    chosenProduct: getPremierCollectionShopChosenProduct(state),
    hasFailed: hasPremierCollectionShopFailed(state),
    premierCollectionShopStep: premierCollectionShopProgressSelector(state),
    cheapestProduct: getCheapestProduct(state),
    viewedPremierCollectionDetailsProperties:
      getViewedPremierCollectionDetailsProperties(state),
    largestEarnAccount: getRewardsAccountWithLargestEarnForBanner(state),
    nightCount: getNightCount(state),
    rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
    cancellationSummary: getPremierCollectionShopCancellationSummary(state),
    isShopCallFromShopDetails: getShopCallFromShopDetails(state),
    shopCallFailureUrl: getShopCallFailureUrl(state),
    isTravelApp: getIsTravelApp(state),
  };
};

export const mapDispatchToProps = {
  shopCallFromShopDetails: shopDetailsActions.shopCallFromShopDetails,
  setIsTravelApp,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMobileShop = withRouter(connector(MobileShop));
